import { gql } from "@apollo/client";

export default gql`
  mutation updateUser($data: UpdateUserInput!){
    updateUser(data: $data){
        success
        data{
            _id
            name
            surname
            role
            phone
            email
            createdAt
        }
        code
        message
    }
}
`
